import {useContext, useState} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import AtomImage, {FETCHPRIORITY} from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'

import {BASE_CLASS} from '../config.js'
import PlayButton from './PlayButton.js'
import VideoPlayer from './VideoPlayer.js'

const DealerImagePreview = ({dealerId, image, name, videos}) => {
  const {domain} = useContext(Context)
  const config = domain.get('config')
  const isMobile = config.get('isMobile')

  const isDesktop = !isMobile
  const [isPlaying, setIsPlaying] = useState(false)

  const displayVideoPlayer = videos.length > 0 && (isPlaying === true || !image)

  const mainClass = cx(`${BASE_CLASS}-videoPlayer`, {
    'is-playing': displayVideoPlayer
  })

  const imageNode = image ? <AtomImage fetchpriority={FETCHPRIORITY.HIGH} src={image} /> : null
  const videoNode = displayVideoPlayer ? (
    <VideoPlayer
      dealerId={dealerId}
      src={videos[0].url}
      isPlaying={isPlaying}
      title={name}
      isMobile={isMobile}
      onClosePlayer={() => setIsPlaying(false)}
    />
  ) : null

  return (
    <div className={mainClass}>
      {videoNode || imageNode}

      {videos.length > 0 && displayVideoPlayer === false ? (
        <PlayButton isDesktop={isDesktop} onClick={() => setIsPlaying(!isPlaying)} />
      ) : null}
    </div>
  )
}

DealerImagePreview.propTypes = {
  dealerId: PropTypes.string,
  image: PropTypes.string,
  name: PropTypes.string,
  videos: PropTypes.array
}

export default DealerImagePreview
